import { render, staticRenderFns } from "./RGPDContent.vue?vue&type=template&id=777f7920&scoped=true"
import script from "./RGPDContent.vue?vue&type=script&lang=ts"
export * from "./RGPDContent.vue?vue&type=script&lang=ts"
import style0 from "./RGPDContent.vue?vue&type=style&index=0&id=777f7920&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777f7920",
  null
  
)

export default component.exports